<div class="container-fluid p-0">
  <div class="row" style="width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;">
    <div id="cover" class="col-sm-12 col-md-12 col-xs-12 col-lg-12 col-xl-6">
      <input type="text" [(ngModel)]="term" (keyup)="onKey($event)" required>
      <div class="d-flex justify-content-between mb-2 cont" *ngIf="searchActive !== null" style="padding: 1rem;
    flex-direction: column;
    background: aliceblue;">
        <div *ngFor="let item of markers | filter: term" class="p-2">
          <a id="selectElement" class="mb-1" (click)="onClick(item)" clickable>{{item.title}}</a>
          <!-- <small class=" text-muted">8 days remaining</small>
          <p>{{item}}</p> -->
        </div>
        <!-- <div class="price pt-3 pl-3"> <span class="mb-2">Fixed</span>
          <h5><span>$</span>1,500</h5>
        </div> -->
      </div>
    </div>
  </div>
  <button class="btn" id="miPositionBtn" (click)="findMe()">
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" class="bi bi-pin-map"
      viewBox="0 0 16 16">
      <path fill-rule="evenodd"
        d="M3.1 11.2a.5.5 0 0 1 .4-.2H6a.5.5 0 0 1 0 1H3.75L1.5 15h13l-2.25-3H10a.5.5 0 0 1 0-1h2.5a.5.5 0 0 1 .4.2l3 4a.5.5 0 0 1-.4.8H.5a.5.5 0 0 1-.4-.8l3-4z" />
      <path fill-rule="evenodd"
        d="M8 1a3 3 0 1 0 0 6 3 3 0 0 0 0-6zM4 4a4 4 0 1 1 4.5 3.969V13.5a.5.5 0 0 1-1 0V7.97A4 4 0 0 1 4 3.999z" />
    </svg>
  </button>
  <google-map #map *ngIf="center" height="100vh" width="100%" [zoom]="zoom" [center]="center" [options]="options">

    <map-marker #markerElem="mapMarker" [position]="mipos[0].position" [title]="mipos[0].title"
      [options]="mipos[0].options" *ngIf="mipos" (mapClick)="openInfo2(markerElem, marker)">
    </map-marker>
    <map-marker #markerElem="mapMarker" *ngFor="let marker of markers" [position]="marker.position"
      [title]="marker.title" [options]="marker.options" (mapClick)="openInfo(markerElem, marker)">
    </map-marker>
    <map-info-window>{{ infoContent }}</map-info-window>
  </google-map>

</div>
